//个人中心
const Paired = () =>
    import("../views/paired/paired.vue"); //结对空间
const PartnerSummary = () =>
    import("../views/paired/partner-summary.vue"); //专家-研伴总结

export default [{
    path: "/paired",
    name: "paired",
    component: Paired,
    meta: {
        title: "结对空间",
        keepAlive: false
    },

}, {
    path: "/partnerSummary",
    name: "partnerSummary",
    component: PartnerSummary,
    meta: {
        title: "研伴总结",
        bread: true,
        keepAlive: false
    },

}]